import { render, staticRenderFns } from "./huanong.vue?vue&type=template&id=53f477ba&scoped=true"
var script = {}
import style0 from "./huanong.vue?vue&type=style&index=0&id=53f477ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f477ba",
  null
  
)

export default component.exports